import React from 'react';

function Hero({ setView }) {
  const handleScheduleClick = (e) => {
    e.preventDefault();
    const contactForm = document.querySelector('.contact-section') || document.getElementById('contact-form');
    if (contactForm) {
      contactForm.scrollIntoView({ behavior: 'smooth' });
    } else if (setView) {
      window.history.pushState({}, '', '/contact/');
      setView('contact');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      window.location.href = '/contact/';
    }
  };

  return (
    <section className="hero">
      {/* Background Video */}
      <video 
        className="hero-video-bg" 
        autoPlay 
        loop 
        muted 
        playsInline
      >
        <source src="/assets/images/8865896-hd_1920_1080_25fps.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Overlay to dim video background */}
      <div className="hero-overlay"></div>

      {/* Hero Content */}
      <div className="container hero-container">
        <div className="hero-content">
          <p className="hero-tagline">Leading IT & BPO Company In Pakistan</p>
          <h1 className="hero-title">
            Leading IT and<br />
            BPO Company In Pakistan
          </h1>
          <p className="hero-description">
            Take your business to the next level with our BPO services and IT company. 
            We've been working since 2016 with a creative and innovative team that 
            help you manage and control digital operations. We don't just build 
            systems; we build the future.
          </p>
          
          <button className="btn-schedule" onClick={handleScheduleClick}>
            Schedule a Call 
            <svg 
              width="18" 
              height="18" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="3" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            >
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </button>

          {/* Featured In Section */}
          <div className="featured-section">
            <span className="featured-text">Featured In</span>
            <div className="featured-divider"></div>
            <div className="featured-badges">
              <img 
                src="/assets/images/clutch_rating-1.png" 
                alt="Clutch" 
                className="badge-img" 
              />
              <img 
                src="/assets/images/goodfrims-1.png" 
                alt="GoodFirms" 
                className="badge-img" 
              />
              <img 
                src="/assets/images/rightfirms-1.png" 
                alt="RightFirms" 
                className="badge-img" 
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
